import { render } from "./Row.vue?vue&type=template&id=68951784&ts=true"
import script from "./Row.vue?vue&type=script&lang=ts"
export * from "./Row.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__